import { arrayMove } from "@dnd-kit/sortable";

const handleDragEnd = (event, { setThumbnails, thumbnails }) => {
  const { active, over } = event;

  if (!active || !over) return;

  if (active.id === over.id) return;

  const getOldPos = (id) => thumbnails.findIndex((thumbnail) => thumbnail.id === id);

  const originalPos = getOldPos(active.id);
  const newPos = getOldPos(over.id);

  setThumbnails((thumbnails) => {
    return arrayMove(thumbnails, originalPos, newPos);
  });
};

export default handleDragEnd;